/**
 * ETL designer page (ADR-0038, P4) — full-bleed canvas at `/etl/:id`.
 * Thin wrapper that reads the route param and mounts the `EtlEditor`.
 */
import { useParams } from "react-router-dom";

import { EtlEditor } from "@/components/etl/EtlEditor";

export function EtlEditorPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  // Full-height canvas — no PageContainer padding (the editor owns its chrome).
  return (
    <div className="h-[calc(100vh-3.5rem)]">
      <EtlEditor pipelineId={id} />
    </div>
  );
}
